import { Filter } from '../ts/helpers/Filter';
import { FlowDetailInfo, FlowListItemInfo } from '../ts/models/FlowInfo';
import { IContentInfo } from '../ts/models/IContentInfo';
import { Flows } from './resources/Flows';

export function getFlowDetailInfo(flowId: string): Promise<FlowDetailInfo> {
  return Flows.getById(flowId);
}

export function getFlowListItemInfos(flows: IContentInfo[]): Promise<FlowListItemInfo[]> {
  const flowIdArray = flows.map(flow => flow.id);
  return Flows.all()
    .addFilter(Filter.stringFieldInArray('id', flowIdArray))
    .getSlice(0, flows.length)
    .then(list => {
      return list.items;
    });
}
